<template>
  <div class="main-left-tree">
    <div class="main-left-header">
      <div class="star-project-btn" @click="checkStarProject" :class="{'cross-btn-chose': $route.meta.treeActive === '/starProject'}">
        <i class="icon iconfont iconicon_quick_access"></i>
        <p>快速访问</p>
      </div>
      <div class="cross-btn" @click="checkCross" :class="{'cross-btn-chose': $route.meta.treeActive === '/crossProject'}">
        <span><i class="icon iconfont iconicon_team_project"></i>跨团队项目</span>
        <span class="task-badge" v-show="isHasDot"></span>
      </div>
      <div class="title">
        <span style="cursor: auto;">团队项目</span>
        <el-dropdown trigger="click" v-permission="['项目管理-新增业务板块','项目管理-所有项目列表', '项目模板管理']">
          <div class="el-dropdown-link activeStyle">
            <i class="icon iconfont iconicon_more_task1 activeIconHover"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-permission="'项目管理-新增业务板块'"  @click.native="checkBusiness">
              <div class="dropdown-item">
                <i class="icon iconfont iconicon_new_subproject"></i>
                业务板块管理
              </div>
            </el-dropdown-item>
            <el-dropdown-item v-permission="'项目管理-所有项目列表'"  @click.native="$router.push('/projectSetting')">
              <div class="dropdown-item">
                <i class="icon iconfont iconicon_project_management"></i>
                项目管理
              </div>
            </el-dropdown-item>
            <el-dropdown-item v-permission="'项目模板管理'">
              <div class="dropdown-item" @click="$router.push('/templateProject')">
                <i class="icon iconfont iconicon_log"></i>
                项目模板管理
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="tree-box">
      <el-tree :default-expanded-keys="expandEle" :load="loadNode" lazy ref="tree" highlight-current :expand-on-click-node="true" @node-click="handleNodeClick" node-key="id" :props="{label: 'title', isLeaf: 'isLeaf'}" :current-node-key="currentNodeKey" v-if="showTree">
        <span class="custom-tree-node" slot-scope="{ node }">
          <div class="tip-box">
            <toolTip maxWidth="72%" :title="node.label">
              <span>{{ node.label }}</span>
            </toolTip>
            <div class="count" v-if="node.data.active_project_count && node.data.active_project_count > 0">
              <img src="image/icon/icon_active@2x.png" alt="">
              <span>{{node.data.active_project_count}}</span>
            </div>
          </div>
          <span class="task-badge" v-show="node.data.msgcount > 0"></span>
        </span>
      </el-tree>
    </div>
    <BusinessUnitDialog v-model="show" @businessChange="businessChange"></BusinessUnitDialog>
  </div>
</template>
<script>
import BusinessUnitDialog from '@/views/businessUnit'
import { mapActions } from 'vuex'
import api from '@/services/api/home/home'
import { mapState } from 'vuex'
export default {
  components: {
    BusinessUnitDialog
  },
  data() {
    return {
      dataset: [],
      expandEle: [],
      dialogData: {},
      isOnce: true,
      currentNodeKey: '',
      isHasDot: false,
      show: false,
      showTree: true
    }
  },
  computed: {
    ...mapState('home/home', {
      countNumber: state => state.countNumber
    })
  },
  watch: {
    $route: {
      handler() {
        if(this.$route.meta.treeActive === '/crossProject') {
          this.$refs.tree.setCurrentKey(null)
        }
      }
    },
    countNumber: {
      handler() {
        if(this.countNumber) {
          this.isHasDot = this.countNumber.some(res => {
            return res.msgcount > 0
          })
        }
      },
      immediate: true
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions('project/project', ['getDepartmentProjectfolder']),
    async loadNode(node, resolve) {
      if(node.level === 0) {
        let result = await api.departmentCategoryIndex({})
        result.forEach(res => {
          this.$set(res, 'title', res.name)
          this.$set(res, 'isLeaf', false)
          this.$set(res, 'id', res.department_category_id)
        })
        return resolve(result)
      }
      let result = await api.businessCategoryIndex({department_category_id: node.data.department_category_id})
      result.forEach(res => {
        this.$set(res, 'isLeaf', true)
        this.$set(res, 'department_category_id', node.data.department_category_id)
        this.$set(res, 'department_category_name', node.data.department_category_name)
        this.$set(res, 'project_list_title', node.data.title)
        this.$set(res, 'id', node.data.id + '-' + res.project_list_id)
      })
      resolve(result)
    },
    openDialog(node) {
      console.log(node)
      this.dialogData.project_depart_id = node.data.department_category_id
      this.dialogData.project_list_id = node.data.project_list_id
      this.$emit('openDialog', this.dialogData)
    },
    async init() {
      let project_depart_id = this.$route.query.project_depart_id
      let project_list_id = this.$route.query.project_list_id
      this.currentNodeKey = project_depart_id + '-' + project_list_id
      if(project_depart_id) {
        this.expandEle = [Number(project_depart_id)]
      }
    },
    handleNodeClick(node,n) {
      console.log(node,n)
      this.crossChose = false
      if(!n.isLeaf) return
      this.$router.push({
        path: "projectFolder",
        query: {
          project_depart_id: node.department_category_id,
          project_list_id: node.project_list_id,
          department_category_name: node.department_category_name,
          // project_depart_name: this.departmentList[node.department_category_id]
          project_depart_name: node.project_list_title

        }
      })
    },
    checkStarProject() {
      this.$router.push('/main/myProject/starProject')
      this.$refs.tree.setCurrentKey(null)
    },
    checkCross() {
      this.$router.push('/main/myProject/crossProject')
      this.$refs.tree.setCurrentKey(null)
    },
    checkBusiness() {
      this.show = true
    },
    businessChange() {
      this.showTree = false
      this.init()
      this.$nextTick(() => {
        this.showTree = true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.main-left-tree {
  padding:0;
  height: 100%;
  width: 206px;
  min-width: 206px;
  border-right:1px solid #E7E8ED;
  box-sizing: border-box;
  z-index:1;
  display: flex;
  flex-direction: column;
  .footer {
    padding-bottom: 32px;
    padding-top: 18px;
    text-align: center;
    /deep/ {
      .wf-button {
        display: block !important;
        margin: 0 16px;
      }
    }
  }
  .tree-box {
    flex: 1;
    overflow: overlay;
    overflow-x: hidden;
    padding: 0 8px;
    display: flex;
    flex-direction: column;
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: rgba(32, 32, 32, 0.6);
    padding: 16px 24px;
    font-size: 14px;
    border-top: 1px solid rgba(231,232,237,0.6);
    /deep/{
      cursor: pointer;
      .tool-tip {
        &:hover {
          color: $color-active !important;
        }
      }
    }
    i {
      font-size: 14px;
      cursor: pointer;
    }
  }
  .cross-btn,
  .star-project-btn {
    height: 48px;
    line-height: 48px;
    padding:0 16px;
    margin: 16px 8px 11px 8px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.star-project-btn {
      justify-content: left;
    }
    &:hover{
      background-color: rgba(32, 32, 32, 0.04);
    }
    i{
      font-size: 16px;
      margin-right: 18px;
      color: #2682FF;
      font-weight: 400;
    }
    .num {
      font-size: 12px;
      color: rgba(32, 32, 32, 0.6);
      font-weight: 400;
    }
  }
  .star-project-btn i {
    color: #FFBE23;
  }
  .star-project-btn {
    margin-bottom: 0;
  }
  .cross-btn {
    margin-top: 0;
  }
  .cross-btn-chose{
    background-color: rgba(32, 32, 32, 0.08) !important;
  }
}
.el-tree-node__label{
    @include ellipsis();
    width: 90%;
}
/deep/{
  .el-tree{
    height: 0;
    flex: 1;
    .el-tree-node{
      padding-bottom: 6px;
    }
    >.el-tree-node{
      padding-bottom: 6px;
        >.el-tree-node__content{
        font-weight: bold;
      }
    }
  }
  .el-tree .el-tree-node__content{
    padding-right:16px;
    border-radius: 4px;
    padding-left: 8px !important;
  }
  .el-tree .el-tree-node__children {
    margin-top: 6px;
    .el-tree-node__content {
      padding-left: 0 !important;
      height: 48px !important;
    }
  }
  .custom-tree-node{
    overflow: hidden;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    i {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
    }
    .tree-count{
      font-size: 12px;
      color: rgba(32, 32, 32, 0.6);
      font-weight: 400;
    }
    .count {
      display: flex;
      align-items: center;
      padding-left: 10px;
      line-height: 1;
      img {
        width: 14px;
        height: 14px;
      }
      span {
        font-size: 12px;
        color: rgba(32, 32, 32, 0.80);
        padding-left: 3px;
      }
    }
    .tip-box {
      display: flex;
      align-items: center;
      width: 0;
      flex: 1;
    }
  }

}
</style>
